import { initState } from './store';

const configureLangStore = () => {
    const actions = {
        SET_LANG: (currentState, payload) => {
            return { lang: payload.lang };
        },
    }

    initState(actions, { lang: 'en' });
}

export default configureLangStore;